export const DEFAULT_CLEAR_ALERTS_TIMEOUT_MS = 5000
